import { render, staticRenderFns } from "./RicOther.vue?vue&type=template&id=151514b0"
import script from "./RicOther.vue?vue&type=script&lang=js"
export * from "./RicOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports